import { Button, Col, Form, Row } from "antd";
import React from "react";
import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";

function OwnerConcerns() {
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
      <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Owner Concerns:" />
          </Col>
          <Col span={24}>
            <h1>There is nothing here</h1>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Next</Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default OwnerConcerns;
